// components/InvoiceGenerator.js
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";

export const generateInvoice = async (invoiceData) => {
  const preview = document.getElementById(`invoice-preview-${invoiceData._id}`);

  if (!preview) {
    console.error("Invoice element not found");
    return;
  }

  // Clone to allow clean print
  const clone = preview.cloneNode(true);
  clone.style.display = "block";
  clone.style.position = "absolute";
  clone.style.left = "-9999px";
  clone.style.width = "210mm"; // A4 width
  document.body.appendChild(clone);

  const canvas = await html2canvas(clone, {
    scale: 3,
    useCORS: true,
    logging: true,
  });
  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  pdf.save(`Invoice_${invoiceData.ticket_id}.pdf`);

  document.body.removeChild(clone);
};